<!-- eslint-disable -->
<template lang="pug">
		.row
				.datepicker-calendar.datepicker-calendar--small-columns(v-if="time === 'Day'")
						.datepicker-calendar__cell(
								v-for="dayOfWeek in daysOfWeek"
								:key="dayOfWeek.timestamp"
						)
								span.datepicker-calendar__day-header {{ dayOfWeek }}
						template(v-if="blankDays > 0")
								.datepicker-calendar__cell(
										v-for="blankDay in blankDays"
										:key="blankDay.timestamp"
								)
										span.datepicker-calendar__blank
						.datepicker-calendar__cell(
								v-for="day in items"
								:key="day.timestamp"
						)
								span.datepicker-calendar__cell-item(
										:class="getCellClasses(day)"
										@click="select(day)"
								) {{ day.date }}
				.datepicker-calendar.datepicker-calendar--big-columns(v-else)
						.datepicker-calendar__cell(
								v-for="item in items"
								:key="item.timestamp"
						)
								span.datepicker-calendar__cell-item(
										:class="getCellClasses(item)"
										@click.stop="select(item)"
								)
										template(v-if="time === 'Month'")
												| {{ item.month }}
										template(v-if="time === 'Year'")
												| {{ item.year }}
</template>

<script>
    /*eslint-disable*/
    export default {
        name: "DatepickerCalendar",
        status: "ready",
        release: "1.0.0",
        props: {
            /**
             * Select function
             */
            select: Function,
            /**
             * Time
             * `Day, Month, Year`
             */
            time: {
                type: String,
                default: "Day",
                validator: value => {
                    return value.match(/(Day|Month|Year)/)
                },
            },
            /**
             * Array of days, months or years
             */
            items: Array,
            /**
             * Days of week array
             */
            daysOfWeek: Array,
            /**
             * Blank days
             */
            blankDays: Number,
        },
        methods: {
            getCellClasses(item) {
                return {
                    "datepicker-calendar__cell-item--selected": item.isSelected,
                    "datepicker-calendar__cell-item--disabled": item.isDisabled,
                    'datepicker-calendar__cell-item--highlighted': item.isHighlighted,
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .datepicker-calendar {
		    @include make-grid($space-x-small);
    }

    .datepicker-calendar--big-columns .datepicker-calendar__cell {
        @include make-col(1, 3, $space-x-small);
    }

    .datepicker-calendar--small-columns .datepicker-calendar__cell {
        @include make-col(1, 7, $space-x-small);
    }

    .datepicker-calendar--small-columns .datepicker-calendar__cell-item {
        @include inset-squish-space($space-x-small);
    }

    .datepicker-calendar__day-header,
    .datepicker-calendar__blank {
        @include make-col(1, 1, $space-x-small);
        @include text($font-size-12);
        @include inset-squish-space($space-x-small);
        color: $color-grey-700;
        text-align: center;
    }

    .datepicker-calendar__cell-item {
		    @include make-col(1, 1, $space-x-small);
		    @include text($font-size-12);
		    @include inset-space($space-x-small);
		    text-align: center;
		    cursor: pointer;
		    color: $color-shark;
		    border-radius: $border-radius-3;

		    &:hover {
				    background-color: $color-green-500;
				    color: $x-color-white;
		    }
    }

    .datepicker-calendar__cell-item--disabled {
        color: $color-grey-700;
        cursor: default;
        pointer-events: none;
        &:hover {
            background-color: $x-color-white;
            color: $color-grey-700;
        }
    }

    .datepicker-calendar__cell-item--selected {
        background-color: $color-blue-400;
        color: $x-color-white;
    }

    .datepicker-calendar__cell-item--highlighted {
        background-color: $color-blue-400;
        color: $x-color-white;
    }
</style>
